import { render, staticRenderFns } from "./logwood-table.vue?vue&type=template&id=56c9e670&"
import script from "./logwood-table.vue?vue&type=script&lang=ts&"
export * from "./logwood-table.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c9e670')) {
      api.createRecord('56c9e670', component.options)
    } else {
      api.reload('56c9e670', component.options)
    }
    module.hot.accept("./logwood-table.vue?vue&type=template&id=56c9e670&", function () {
      api.rerender('56c9e670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/components/logwood-table.vue"
export default component.exports